import React, { useState, useEffect } from "react";
import {
  Box, Grid, TextField, FormControl, InputLabel, Select, MenuItem,
  Checkbox, FormControlLabel, Typography, Button, Switch, Divider,
  Paper,
  FormHelperText,
  Autocomplete,
  CircularProgress,
} from "@mui/material";
import axios from "axios";
import { get, post } from "src/services/httpClient.service";
import { useSnackbar } from "src/components/snackbar/useSnackbar";
import { authenticationService } from "src/services/authentication.service";
import { useNavigate } from "react-router";
import { useAppConfig } from "src/components/AppConfigContext/AppConfigContext";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

interface AddOperatorProps {
  onClose: () => void;
  onSuccess: () => void;
}

const AddOperator: React.FC<AddOperatorProps> = ({ onClose, onSuccess }) => {
  const navigate = useNavigate()



  const [formData, setFormData] = useState({
    companyId: "",
    company: "",
    role: "",
    operatorName:"",
    email: "",
    password: "",
    mobile: "",
    phone: "",
    address1: "",
    address2: "",
    areaId: "",
    accountType: "",
    zone: "",
    lcoId: "",
    distributorId: "",
    franchiseId: "",
    franchisees: [] as string[], 
    selectAll: false,
    enableFreeAccess: false, 
    allowNstvIrdCondition: false, 
    allowLowBalanceRecharge: false, 
    status: true,
    roleIdsList: [] as string[], 
    franchiseIdsList: [] as string[], 
    vendorId: "",
    franchiseName: '',
    franchiseCode: '',
    billingTaxId:'',
    priceListId: '',
    openingAmount: '',
    creditLimit: ''
  });

  const API_URL = process.env.REACT_APP_BASE_API_URL;
  const accountType = localStorage.getItem('accountType');
  const selectedFranchise = localStorage.getItem('selectedFranchise');
  const operatorData = JSON.parse(localStorage.getItem("operatorData") || "{}");
  const parsedFranchise = selectedFranchise ? JSON.parse(selectedFranchise) : null;

  const [showPassword, setShowPassword] = useState(false);

  const [states, setStates] = useState<string[]>([]);
  const [cities, setCities] = useState<string[]>([]);
  const [loadingCities, setLoadingCities] = useState(false);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const franchiseeList = ["Franchisee A", "Franchisee B", "Franchisee C", "Franchisee D"];

  const { showSnackbar } = useSnackbar();
  const { isLcoId } = useAppConfig();
  const { vendorId, franchiseId } = authenticationService.getVendorFranchiseIds();
  const [companiesList, setCompanies] = React.useState([]);
  const [franchiseList, setFranchisees] = React.useState([]);
  const [distributorsList, setDistributorsList] = React.useState([]);
  const [rolesList, setRoles] = React.useState([]);
  const [areaList, setAreaList] = React.useState([]);
  const [selectedBillingAreaId, setSelectedBillingAreaId] = React.useState('');
  const [zonesList, setZonesList] = React.useState([]);
  const [showLcoId, setShowLcoId] = useState(true);

  const [priceLists, setPriceLists] = React.useState([]);
  const [billingTaxTypes, setBillingTaxTypes] = React.useState([]);
  const [loading, setLoading] = useState(false);

  const operatorTypeAccount = localStorage.getItem('operatorData')
  const operatorAccountConvert = JSON.parse(operatorTypeAccount)
  const [operatorAccountType, setOperatorAccountType] = useState<any>(operatorAccountConvert?.accountType)

  //add companyName & franchiseId from localSstorageValues
  useEffect(() => {
  if (operatorAccountType === "DISTRIBUTOR" && parsedFranchise) {
    setFormData((prev) => ({
      ...prev,
      franchiseId: parsedFranchise.id,
      companyId: parsedFranchise.companyId,

      // ✅ THIS IS REQUIRED
      franchiseIdsList: parsedFranchise?.id ? [parsedFranchise.id] : []
    }));
  }
}, [operatorAccountType]);

  const fetchAreas = async () => {
    try {
      const response = await get(`${API_URL}/api/miscellaneous/area/vendor/${vendorId}/findAll`);
      if (response) setAreaList(response?.data);
      //console.log('city',response?.data)
    } catch (error) {
      console.error("Error fetching areas", error);
    }
  };

  const fetchZones = async () => {
    try {
      
      const response = await get(`${API_URL}/api/miscellaneous/zone/vendor/${vendorId}/findAll`)
      console.log('response1',response)
      if (response) setZonesList(response?.data);
      //console.log('city',response?.data)
    } catch (error) {
      console.error("Error fetching areas", error);
    }
  };

  React.useEffect(() => {
    fetchAreas();
    //fetchZones();
  }, []);


  const fetchCompanies = async () => {
    try {
      const response = await get(`${API_URL}/api/company/vendor/${vendorId}/fetchAll`);
      console.log('response', response)
      if (response) {
        setCompanies(response);
      }
    } catch (error) {
      console.error("Error fetching companies:", error);
      showSnackbar("Failed to load company list", "error");
    }
  };

  const fetchDistributors = async (companyId) => {
    try {
      // const response = await get(
      //   `${API_URL}/api/operators/vendor/${vendorId}/getDistributorsListByCompanyId`,
      //   { params: { companyId } }
      // );

      const response = await get(`${API_URL}/api/operators/vendor/${vendorId}/getOperatorAccountTypeList`, {params: {accountTypes: "OWNER,DISTRIBUTOR", companyId: companyId}});

      // ✅ Your API returns array directly
      if (Array.isArray(response?.data)) {
        if (response.length === 0) {
          showSnackbar("No Distributors List present for this Company", "error");
        }
        setDistributorsList(response?.data);
      } else {
        console.error("Unexpected API response:", response);
        showSnackbar("Failed to load Distributors list", "error");
      }
    } catch (error) {
      console.error("Error fetching Distributors:", error);

      if (error?.response?.status === 404) {
        showSnackbar("No Distributors List present for this Company", "error");
      } else {
        showSnackbar("Failed to load Distributors list", "error");
      }
    }
  };

  const fetchFranchisees = async (companyId) => {
    try {
      const response = await get(
        `${API_URL}/api/franchisees/vendor/${vendorId}/findByCompanyId`,
        { params: { companyId } }
      );

      console.log("Franchise response:", response);

      // ✅ Your API returns array directly
      if (Array.isArray(response?.data)) {
        if (response.length === 0) {
          showSnackbar("No Franchise List present for this Company", "error");
        }
        setFranchisees(response?.data);
      } else {
        console.error("Unexpected API response:", response);
        showSnackbar("Failed to load franchise list", "error");
      }
    } catch (error) {
      console.error("Error fetching franchisees:", error);

      if (error?.response?.status === 404) {
        showSnackbar("No Franchise List present for this Company", "error");
      } else {
        showSnackbar("Failed to load franchise list", "error");
      }
    }
  };

  const fetchRoles = async () => {
    try {

      let response = null;
      if (accountType !== null && accountType !== undefined && accountType.trim() === "DISTRIBUTOR") {
        response = await get(`${API_URL}/api/globalRole/vendor/${vendorId}/findAllDistributorRoles`);
      } else {
        response = await get(`${API_URL}/api/globalRole/vendor/${vendorId}/franchise/${franchiseId}/findAll`);
      }
      //const response = await get(`${API_URL}/api/globalRole/vendor/${vendorId}/franchise/${franchiseId}/findAll`);
      if (response && response.data && Array.isArray(response.data)) {
        setRoles(response.data);   // << Use data.data
      } else {
        console.error("Unexpected API response:", response);
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
      showSnackbar("Failed to load roles list", "error");
    }
  };

  const fetchPriceListByVendor = async () => {
    try {
      const response = await get(
        `${API_URL}/api/area-wise-price-list/vendor/${vendorId}/getPriceListsByVendorId`
      );

      console.log("Price List API Response:", response);
      if (response?.data && Array.isArray(response.data)) {
        setPriceLists(response.data);
      } else {
        setPriceLists([]);
      }

    } catch (error) {
      console.error("Error fetching price list:", error);
      setPriceLists([]);
    }
  };

  const billingTaxType = async () => {
      try {
        const res = await get(
          `${API_URL}/api/billing-tax-type/vendor/${vendorId}/getAll`
        );
    
        if (res?.success && res?.data) {
          setBillingTaxTypes(res.data);
        }
      } catch (error) {
        console.error("Error fetching billing tax types", error);
      }
    };

  useEffect(() => {
    billingTaxType();
    fetchPriceListByVendor();
    fetchCompanies();
    fetchRoles();
    setFranchisees([]);
  }, []);

  // Fetch all states on load
  // useEffect(() => {
  //   const fetchStates = async () => {
  //     try {
  //       const response = await get(`${API_URL}/states`);
  //       setStates(response || []);
  //     } catch (error) {
  //       console.error("Error fetching states:", error);
  //     }
  //   };
  //   fetchStates();
  // }, []);

  // Fetch cities based on selected state
  /* useEffect(() => {
    if (!formData.state) return;
    const fetchCities = async () => {
      setLoadingCities(true);
      try {
        const response = await get(`${API_URL}/cities?stateName=${formData.state}`);
        setCities(response || []);
      } catch (error) {
        console.error("Error fetching cities:", error);
        setCities([]);
      } finally {
        setLoadingCities(false);
      }
    };
    fetchCities();
  }, [formData.state]); */

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    // Reset city when state changes
    if (name === "state") {
      setFormData((prev) => ({ ...prev, state: value, city: "" }));
    }
    
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleCheckboxChange = (franchisee: string) => {
    setFormData((prev) => {
      const isSelected = prev.franchisees.includes(franchisee);
      const updatedList = isSelected
        ? prev.franchisees.filter((f) => f !== franchisee)
        : [...prev.franchisees, franchisee];
      return { ...prev, franchisees: updatedList };
    });
  };

  const handleSelectAll = () => {
    setFormData((prev) => ({
      ...prev,
      selectAll: !prev.selectAll,
      franchisees: prev.selectAll ? [] : [...franchiseeList],
    }));
  };

  const handleSwitchChange = (e: any) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({ ...prev, [name]: checked }));
  };

  // 🧠 Validation logic
  const validate = () => {
    let tempErrors: { [key: string]: string } = {};

    console.log('formData',formData)

    //if (!formData.companyId) tempErrors.companyId = "Company is required";
    if (operatorAccountType === "OWNER" && !formData.companyId) {
  tempErrors.companyId = "Company is required";
}
    //if (!formData.role) tempErrors.role = "Role is required";
    if (!formData.operatorName.trim()) {
  tempErrors.operatorName = "Name is required";
} else if (formData.operatorName.trim().length < 3) {
  tempErrors.operatorName = "Name must be at least 3 characters";
}
    if (!formData.accountType) tempErrors.accountType = "Account Type is required";
    if (!formData.areaId) tempErrors.areaId = "Address is required";
    //if (!formData.country) tempErrors.country = "Country is required";
    // if (!formData.state) tempErrors.state = "State is required";
    // if (!formData.zone) tempErrors.zone = "Zone is required";
    //if (!formData.city) tempErrors.city = "City is required";
    if (!formData.email) tempErrors.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.email)) tempErrors.email = "Enter a valid email";
    if (!formData.password) tempErrors.password = "Password is required";
    else if (formData.password.length < 6) tempErrors.password = "Password must be at least 6 characters";
    if (formData.roleIdsList.length === 0) tempErrors.roleIdsList = "Select at least one role";


    if (!formData.phone) {
  tempErrors.phone = "phone number is required";
} else if (!/^\d{10}$/.test(formData.phone)) {
  tempErrors.phone = "phone number must be 10 digits";
}
    // if (accountType === "OWNER" && formData.franchiseIdsList.length === 0) {
    //   tempErrors.franchiseIdsList = "Select at least one franchise";
    // }

    if (formData.accountType === "LCO" && !operatorData.id) {
      tempErrors.distributorId = "Distributor is required";
    }

    if (formData.accountType === "DISTRIBUTOR" && !formData.priceListId) {
      tempErrors.priceListId = "Price Template is required";
    }

    //if (!formData.priceListId) tempErrors.priceListId = "Price Template is required";

    // if (
    //   operatorAccountType === "OWNER" &&
    //   formData.accountType === "DISTRIBUTOR" && !formData.franchiseId
    // ) {
    //     tempErrors.franchiseId = "Franchise is required";
    // }
     console.log('tempErrors',tempErrors)
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  useEffect(() => {
  if (operatorAccountType === "DISTRIBUTOR") {
    setFormData(prev => ({ ...prev, accountType: "LCO" }));
  }
}, [operatorAccountType]);

  const handleSubmit = async () => {

    console.log("✅ Submitted data:", formData);

    if (!validate()) return; // stop submit if invalid
   setLoading(true);
    

    try {
      /* const payload = {
        ...formData,
        vendorId,
        franchiseId,
        accountType:
          operatorAccountType === "DISTRIBUTOR"
            ? "LCO"
            : formData.accountType
      }; */

      const payload = {
        ...formData,

        
        
        lcoId: isLcoId && formData.lcoId ,
        vendorId,

         distributorId:
    operatorAccountType === "DISTRIBUTOR"
      ? operatorData.id
      : formData.distributorId,



        companyId:
          operatorAccountType === "DISTRIBUTOR"
            ? operatorData?.companyId
            : formData.companyId,

       franchiseId:
          operatorAccountType === "DISTRIBUTOR"
            ? operatorData?.franchiseId
            : formData.franchiseId,

        // ✅ MAIN FIX
        franchiseIdsList:
          operatorAccountType === "DISTRIBUTOR"
            ? [parsedFranchise?.id]
            : formData.franchiseIdsList,

        accountType:
          operatorAccountType === "DISTRIBUTOR"
            ? "LCO"
            : formData.accountType
      };

      console.log('payloadd',payload)

      const response = await post(`${API_URL}/api/operators`, payload);
      console.log('payload',payload)
      console.log('response', response)
      if (response || response || Array.isArray(response)) {

        showSnackbar("Added Successfully", "success");
        navigate('/operator')

      } else {
        console.error("Unexpected API response:", response);
        showSnackbar("Unexpected API response:", "error");
      }
    } catch (error) {
      console.error("Error fetching franchisees:", error?.response?.data?.message);
      showSnackbar((error?.response?.data?.message || "Failed to load franchise list"), "error");
    }finally {
    setLoading(false);
  }


  };

  const handleCancel = () => {
    setFormData({
      companyId: "", company: "", role: "", operatorName: "", email: "", password: "", mobile: "",
      phone: "", address1: "", address2: "", accountType: "",
      zone: "",lcoId:"", areaId: "",
      franchisees: [],
      selectAll: false, enableFreeAccess: false, allowNstvIrdCondition: false,
      allowLowBalanceRecharge: false, status: true, franchiseIdsList: [], roleIdsList: [], vendorId: "", franchiseId: "",
      distributorId: "",franchiseName: '',
    franchiseCode: '',
    billingTaxId:'',
    priceListId: '',
    openingAmount: '',
    creditLimit: ''
    });
    navigate('/operator')

  };

  const handleRolesChange = (event) => {
    const { value } = event.target;

    setErrors((prev) => ({
      ...prev,
      roleIdsList: "",
    }));
  }

  return (
    <Paper
      elevation={3}
      sx={{
        padding: 4,
        marginX:2,
      
        
        // backgroundColor: '#9ba1b0ff', // subtle gray background
        // color: '#0f0f0fff',
      }}
    >
      <Typography variant="h3" fontWeight="bold" gutterBottom>
        Add Operator
      </Typography>
      <br />
      <Grid container spacing={2}>
        {/* Company, Role, Name */}
      {
        operatorAccountType == "OWNER" && <Grid item xs={12} md={3}>
          <FormControl fullWidth error={!!errors.company}>
            <InputLabel>Company</InputLabel>
            <Select
              name="companyId"
              value={formData.companyId}
              label="Company"
              error={!!errors.companyId}
              onChange={(e) => {
                const selectedId = e.target.value;
                const selectedCompany = companiesList.find((c) => c.id === selectedId);
                fetchFranchisees(selectedId);
                fetchDistributors(selectedId);
                setFormData((prev) => ({
                  ...prev,
                  companyId: selectedId,
                  distributorId: "",
                  franchiseId: "",
                  franchiseIdsList: [],
                  company: selectedCompany ? selectedCompany.companyName : '',
                }));
              }}
            >
              <MenuItem value="">Select Company</MenuItem>
              {companiesList.map((company) => (
                <MenuItem key={company.id} value={company.id}>
                  {company.companyName}
                </MenuItem>
              ))}
            </Select>
            {errors.companyId && <FormHelperText>{errors.companyId}</FormHelperText>}
          </FormControl>
        </Grid>
      } 
       

        <Grid item xs={12} md={3}>
          <FormControl fullWidth error={!!errors.roleIdsList}>
            <InputLabel>Roles</InputLabel>
            <Select
              name="roleIdsList"
              multiple
              value={formData.roleIdsList}
              onChange={(e) => {
                const { value } = e.target;
                setFormData((prev) => ({ ...prev, roleIdsList: typeof value === "string" ? value.split(",") : value }));
                setErrors((prev) => ({ ...prev, roleIdsList: "" }));
              }}
              label="Roles"
              renderValue={(selected) =>
                rolesList
                  .filter((rle) => selected.includes(rle.id))
                  .map((rle) => rle.name)
                  .join(", ")
              }
            >
              {rolesList.map((rle) => (
                <MenuItem key={rle.id} value={rle.id}>
                  <Checkbox checked={formData.roleIdsList.indexOf(rle.id) > -1} />
                  {rle.name}
                </MenuItem>
              ))}
            </Select>
            {errors.roleIdsList && <FormHelperText>{errors.roleIdsList}</FormHelperText>}
          </FormControl>
        </Grid>


        <Grid item xs={12} md={3}>
          <TextField
            label="Name"
            name="operatorName"
            fullWidth
            value={formData.operatorName}
            onChange={handleChange}
            error={!!errors.operatorName}
            helperText={errors.operatorName}
          />
        </Grid>
        {
          operatorAccountType == "OWNER" &&
          <Grid item xs={12} md={3}>
            <FormControl fullWidth error={!!errors.accountType}>
              <InputLabel>Account Type</InputLabel>
              <Select name="accountType" value={formData.accountType} onChange={handleChange}>
                <MenuItem value="DISTRIBUTOR">Distributor</MenuItem>
                <MenuItem value="LCO">LCO</MenuItem>
              </Select>
              {errors.accountType && <FormHelperText>{errors.accountType}</FormHelperText>}
            </FormControl>
          </Grid>
        }

        {operatorAccountType === "OWNER" && formData.accountType === "LCO" && (

          <Grid item xs={12} md={3}>
              <FormControl fullWidth error={!!errors.distributorId}>
                  <InputLabel>Distributor</InputLabel>

                  <Select
                      name="distributorId"
                      value={formData.distributorId}
                      label="Distributor"
                      onChange={handleChange}
                  >
                      <MenuItem value="">
                          Select Distributor
                      </MenuItem>

                      {distributorsList.map((d:any) => (
                          <MenuItem key={d.id} value={d.id}>
                              {d.operatorName}
                          </MenuItem>
                      ))}
                  </Select>

                  {errors.distributorId &&
                      <FormHelperText>{errors.distributorId}</FormHelperText>}
              </FormControl>
          </Grid>

          )}

          {operatorAccountType === "OWNER" && formData.accountType === "DISTRIBUTOR" && (

            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                  <InputLabel>Franchise</InputLabel>

                 <Select
  value={formData.franchiseId}
  onChange={(e) => {
    const selectedId = e.target.value;

    const selectedFranchise = franchiseList.find(
      (f: any) => f.id === selectedId
    );

    // Find matching area from areaList using franchise area name
    const selectedArea = areaList.find(
      (a: any) =>
        a.name?.trim().toLowerCase() ===
        selectedFranchise?.area?.trim().toLowerCase()
    );

    console.log("Selected Franchise:", selectedFranchise);
    console.log("Selected Area:", selectedArea);

    setFormData((prev) => ({
      ...prev,
      franchiseId: selectedId,
      franchiseName: selectedFranchise?.name || "",
      franchiseCode: selectedFranchise?.franchiseeCode || "",
      priceListId: selectedFranchise?.priceListId || "",
      billingTaxId: selectedFranchise?.billingTaxId || "",
      openingAmount: selectedFranchise?.openingAmount || "",
      creditLimit: selectedFranchise?.creditLimit || "",

      // Auto select Area (City)
      areaId: selectedArea?.id || "",
    }));
  }}
  renderValue={(selected) =>
    franchiseList.find((f: any) => f.id === selected)?.name || ""
  }
>
  {franchiseList.map((f: any) => (
    <MenuItem key={f.id} value={f.id}>
      {f.name}
    </MenuItem>
  ))}
</Select>
              </FormControl>
          </Grid>

            )}

        {/* Contact Info */}
        <Grid item xs={12} md={3}>
          <TextField label="Email" name="email" fullWidth value={formData.email} onChange={handleChange} error={!!errors.email} helperText={errors.email} />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField label="Password" name="password" 
          type={showPassword ? "text" : "password"}
          fullWidth value={formData.password} onChange={handleChange} error={!!errors.password} helperText={errors.password}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowPassword((prev) => !prev)}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
     />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
  label="phone"
  name="phone"
  fullWidth
  value={formData.phone}
  onChange={(e) => {
    const value = e.target.value.replace(/\D/g, "");
    setFormData((prev) => ({
      ...prev,
      phone: value,
    }));
    setErrors((prev) => ({
      ...prev,
      phone: "",
    }));
  }}
  error={!!errors.phone}
  helperText={errors.phone}
  inputProps={{
    maxLength: 10,
    inputMode: "numeric",
  }}
/>
        </Grid>




        {/* Franchisee List */}
        {/* {errors.franchiseIdsList && (
          <Typography color="error" variant="caption">
            {errors.franchiseIdsList}
          </Typography>
        )}
       {
        operatorAccountType == "OWNER" && <Grid item xs={12}>
          <Typography variant="subtitle1" sx={{ mb: 1 }}>
            Franchisee List
          </Typography>

          <Box
            sx={{
              border: "1px solid #444",
              borderRadius: "6px",
              padding: "12px",
              maxHeight: "140px", // Show ~4 rows before scroll
              overflowY: "auto",
              display: "flex",
              flexWrap: "wrap",
              gap: "12px"
            }}
          >
            {/* Select All *
            
            <FormControlLabel 
              control={
                <Checkbox 
                  checked={
                    formData.franchiseIdsList.length === franchiseList.length &&
                    franchiseList.length > 0
                  }
                  onChange={() => {
                    if (formData.franchiseIdsList.length === franchiseList.length) {
                      setFormData((prev) => ({ ...prev, franchiseIdsList: [] }));
                    } else {
                      setFormData((prev) => ({
                        ...prev,
                        franchiseIdsList: franchiseList.map((f) => f.id)
                      }));
                    }
                  }}
                />
              }
              label="Select All"
              sx={{ width: "100%" }}
            />

            {/* Franchise Checkboxes *
            {franchiseList.map((f) => (
              <FormControlLabel
                key={f.id}
                control={
                  <Checkbox
                    checked={formData.franchiseIdsList.includes(f.id)}
                    onChange={(e) => {
                      const { checked } = e.target;
                      setFormData((prev) => ({
                        ...prev,
                        franchiseIdsList: checked
                          ? [...prev.franchiseIdsList, f.id]
                          : prev.franchiseIdsList.filter((id) => id !== f.id)
                      }));
                    }}
                  />
                }
                label={f.name}
              />
            ))}
          </Box>

          {errors.franchiseIdsList && (
            <Typography color="error" variant="caption">
              {errors.franchiseIdsList}
            </Typography>
          )}
        </Grid>
       }  */}
       

        {/* <Grid item xs={12}>
          <Divider sx={{ my: 1 }} />
          <Typography variant="h6">Franchisee List</Typography>
          <FormControlLabel
            control={<Checkbox checked={formData.selectAll} onChange={handleSelectAll} />}
            label="Select All"
          />
          <Grid container>
            {franchiseeList.map((f) => (
              <Grid item xs={6} md={3} key={f}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.franchisees.includes(f)}
                      onChange={() => handleCheckboxChange(f)}
                    />
                  }
                  label={f}
                />
              </Grid>
            ))}
          </Grid>
        </Grid> */}

        {/* Address Info */}
        <Grid item xs={12} md={3}>
          <TextField label="Address" name="address1" fullWidth value={formData.address1} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField label="Landmark/Village" name="address2" fullWidth value={formData.address2} onChange={handleChange} />
        </Grid>
        {/* <Grid item xs={12} md={6}>
          <TextField label="Address 3" name="address3" fullWidth value={formData.address3} onChange={handleChange} />
        </Grid> */}

        <Grid item xs={6} >
          <Autocomplete
  options={areaList}
  value={
    areaList.find(
      (a: any) => String(a.id) === String(formData.areaId)
    ) ?? null
  }
  getOptionLabel={(option: any) =>
    `${option.name} / ${option.districtName} / ${option.cityName} / ${option.stateName} / ${option.countryName} / ${option.zipCode}`
  }
  isOptionEqualToValue={(option: any, value: any) =>
    String(option.id) === String(value.id)
  }
  onChange={(_, newValue) => {
    setFormData((prev) => ({
      ...prev,
      areaId: newValue ? newValue.id : "",
    }));
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Area (City)"
      fullWidth
    />
  )}
/>
          {errors.areaId && <FormHelperText error>{errors.areaId}</FormHelperText>}
        </Grid>
        {/* <Grid item xs={12} md={6}>
          <TextField label="Postal Code" name="postalCode" fullWidth value={formData.postalCode} onChange={handleChange} />
        </Grid> */}

        
        {/* <Grid item xs={12} md={3}>
          <TextField label="Mobile" name="mobile" fullWidth value={formData.mobile} onChange={handleChange} />
        </Grid> */}

        {/* <Grid item xs={12} md={3}>
          <FormControl fullWidth error={!!errors.country}>
            <InputLabel>Country</InputLabel>
            <Select name="country" value={formData.country} onChange={handleChange}>
              <MenuItem value="India">India</MenuItem>
            </Select>
            {errors.country && <FormHelperText>{errors.country}</FormHelperText>}
          </FormControl>
        </Grid> */}

        {/* <Grid item xs={12} md={3}>
           <FormControl fullWidth error={!!errors.state}>
            <InputLabel>State</InputLabel>
            <Select name="state" value={formData.state} onChange={handleChange}>
              {states.length > 0 ? (
                states.map((state) => (
                  <MenuItem key={state} value={state}>
                    {state}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No States Found</MenuItem>
              )}
            </Select>
            {errors.state && <FormHelperText>{errors.state}</FormHelperText>}
          </FormControl>
        </Grid>
 */}
        {/* <Grid item xs={12} md={3}>
          <FormControl fullWidth error={!!errors.zone}>
            <InputLabel>Zone</InputLabel>
            <Select
              name="zone"
              value={formData.zone || ''}
              onChange={handleChange}
              label="Zone"
            >
              {zonesList.map((zone) => (
                <MenuItem key={zone.id} value={zone.id}>
                  {zone.name}
                </MenuItem>
              ))}
            </Select>
            {errors.zone && <FormHelperText>{errors.zone}</FormHelperText>}
          </FormControl>
        </Grid> */}

        {isLcoId && (
  <Grid item xs={12} md={3}>
    <TextField
      label="LCO ID"
      name="lcoId"
      fullWidth
      value={formData.lcoId}
      onChange={handleChange}
    />
  </Grid>
)}

        {/*  <Grid item xs={12} md={3}>
          <FormControl fullWidth error={!!errors.city}>
            <InputLabel>City</InputLabel>
            <Select
              name="city"
              value={formData.city}
              onChange={handleChange}
              disabled={!formData.state || loadingCities}
            >
              {loadingCities ? (
                <MenuItem disabled>Loading...</MenuItem>
              ) : cities.length > 0 ? (
                cities.map((city) => (
                  <MenuItem key={city} value={city}>
                    {city}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No Cities Found</MenuItem>
              )}
            </Select>
            {errors.city && <FormHelperText>{errors.city}</FormHelperText>}
          </FormControl>
        </Grid> */}

{formData.accountType === "DISTRIBUTOR" && (
  <>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="Franchise Name"
            name="franchiseName"
            value={formData.franchiseName}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="Franchise Code"
            name="franchiseCode"
            value={formData.franchiseCode}
            onChange={handleChange}
          />
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth error={!!errors.priceListId}>
            <InputLabel>Franchisee PriceList*</InputLabel>
            <Select
              name="priceListId"
              value={formData.priceListId}
              label="Franchisee PriceList*"
              onChange={handleChange}
            // disabled={priceLists.length === 0}
            >
              <MenuItem value="">Select Price List</MenuItem>
              {priceLists.map((p) => (
                <MenuItem key={p.id} value={p.id}>
                  {p.areaName} - {p.locationName}
                </MenuItem>
              ))}
            </Select>
            {errors.priceListId && <FormHelperText error>{errors.priceListId}</FormHelperText>}
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            select
            fullWidth
            label="Billing Tax Type"
            name="billingTaxId"
            value={formData.billingTaxId}
            onChange={handleChange}
           
          >
            {billingTaxTypes.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="Opening Amount"
            name="openingAmount"
            type="number"
            value={formData.openingAmount}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="Credit Limit"
            name="creditLimit"
            type="number"
            value={formData.creditLimit}
            onChange={handleChange}
          />
        </Grid>

</>
)}

        {/* Switches */}
        <Grid item xs={12}>
          <Divider sx={{ my: 1 }} />
          <FormControlLabel
            control={<Switch checked={formData.enableFreeAccess} onChange={handleSwitchChange} name="enableFreeAccess" />}
            label="Free Enable"
          />
          
          <FormControlLabel
            control={<Switch checked={formData.allowLowBalanceRecharge} onChange={handleSwitchChange} name="allowLowBalanceRecharge" />}
            label="Allowed Low Balance Recharge"
          />
          <FormControlLabel
            control={<Switch checked={formData.status} onChange={handleSwitchChange} name="status" />}
            label="Status (Active)"
          />
        </Grid>

        {/* Buttons */}
        <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
         <Button
  variant="contained"
  color="primary"
  sx={{ mr: 2 }}
  onClick={handleSubmit}
  disabled={loading}
  startIcon={
    loading ? <CircularProgress size={20} color="inherit" /> : null
  }
>
  {loading ? "Saving..." : "Save"}
</Button>
          <Button variant="outlined" color="secondary" onClick={handleCancel}>
            Cancel
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default AddOperator;